import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { ToastService } from 'src/app/core/toast/toast.service';
import { BaseResponse } from 'src/app/model/response/base-response';
import { IdbService } from 'src/app/services/idb.service';
import { environment } from 'src/environments/environment';
import { AppGlobalSettings, AppGlobalSettingsRequest } from '../settings';
import { SettingsComponent } from '../settings.component';
import { SettingsService } from '../settings.service';
import { slideDownUp } from 'src/app/core/global-app-animations';

@Component({
    selector: 'app-settings-files',
    templateUrl: './settings-files.component.html',
    styleUrl: './settings-files.component.scss',
    animations: [
        slideDownUp
    ],
    standalone: false
})
export class SettingsFilesComponent implements OnInit, OnDestroy {

  private theEnd$ = new Subject<void>();

  saveFilesOnAzure: boolean = true;

  showMsg: boolean = false;
  message: string = '';

  clickCounter: number = 0;
  globalSettings: AppGlobalSettings | undefined;

  ready: boolean = false;

  // settings

  constructor(
    private root: SettingsComponent,
    private settingsService: SettingsService,
    private idbService: IdbService,
    private router: Router,
    private toastService: ToastService,
  ) {

  }

  ngOnInit(): void {

    if(this.root.fuhrer == false) {
      this.router.navigate([`/home/settings/memory`]);
    }

    this.updateLocalAppSettings();
  }

  ngOnDestroy(): void {
        this.theEnd$.next();
    this.theEnd$.complete();
  }

  updateLocalAppSettings() {

    // check if settings exist in the idb
    this.idbService.getAllData(environment.idbTables.GlobalSettings).then((res: any) => {
      console.warn("\n \n \n GOT THE DATA FROM IDB FOR SETTINGS \n \n \n");
      console.warn(res);

      if (res != undefined) {
        let resData: Array<any> = res;
        if (resData.length == 0) {
          console.warn('no data in idb')
          this.settingsService.GetSettings().pipe(takeUntil(this.theEnd$)).subscribe({
            next: (res: AppGlobalSettings) => {

              if (res != undefined) {

                // update or create settings in local idb
                this.idbService.addItemRow(environment.idbTables.GlobalSettings, res, environment.idbTables.GlobalSettings);
                this.globalSettings = res;
                this.saveFilesOnAzure = this.globalSettings.saveFilesOnAzure;

              } else {
                console.error("\n \n \n \n \n SHIT \n THERE ARE NO SETTINGS 💀💀💀💀💀💀💀💀💀💀💀💀💀💀 \n \n \n \n \n");
                this.saveFilesOnAzure = true;
              }

              this.ready = true;

            },
            error: () => {
              this.ready = true;
            }
          });

        } else {
          console.info("SETTINGS ARE SETTED lol");
          this.globalSettings = res[0].item;
          console.warn(this.globalSettings);
          this.saveFilesOnAzure = this.globalSettings!.saveFilesOnAzure;
          this.ready = true;
        }
      } else {
        this.saveFilesOnAzure = true;
        this.ready = true;
      }

    });



  }

  saveSettings() {
    let req: AppGlobalSettingsRequest = {
      warningOnPiva: this.globalSettings?.warningOnPiva,
      pacchettiUseDateContratti: this.globalSettings?.pacchettiUseDateContratti,
      saveFilesOnAzure: this.saveFilesOnAzure,
    };
    this.clickCounter++;

    if (this.clickCounter == 5) {

      this.message = "Hey, calmati. Aspetta qualche secondo prima di salvare ancora";
      this.clickCounter = 0;
      this.showMsg = true;

      setTimeout(() => {
        this.showMsg = false;
      }, 1000);

    }
    console.warn("THIS IS REQ");
    console.warn(req);
    this.settingsService.UpdateSettings(req).pipe(takeUntil(this.theEnd$)).subscribe({
      next: (res: BaseResponse) => {

        if (res.success == true) {

          this.globalSettings!.saveFilesOnAzure = req.saveFilesOnAzure || true;

          this.message = "Impostazioni aggiornate";
          this.clickCounter = 0;
          this.showMsg = true;

          this.toastService.success('Modifiche salvate');

          this.idbService.addItemRow(environment.idbTables.GlobalSettings, this.globalSettings, environment.idbTables.GlobalSettings);
          setTimeout(() => {
            this.showMsg = false;
          }, 1000);
        }

      },
      error: (res: BaseResponse) => {

        this.message = res.error != undefined ? res.error : "Errore durante il salvataggio, riprova più tardi";
        this.toastService.error( 'Errore durante il salvataggio, riprova più tardi');

        this.showMsg = true;

        setTimeout(() => {
          this.showMsg = false;
        }, 1000);

      }
    });
  }

}

